import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as faker from 'faker/locale/pt_BR';
import { Observable, of, forkJoin } from 'rxjs';
import { UrlApi } from '../Models/url-api.model';
import { Pergunta } from '../Models/pergunta.model';
import { RespostaWebAPI } from '../Models/resposta-web-api.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PerguntaService {

  constructor(private http: HttpClient) { }

  obterPerguntasId(areaParticipacaoId: number): Observable<number[]> {
    return this.mockPerguntasId(areaParticipacaoId);
  }

  obterPerguntaId(perguntaId: number): Observable<RespostaWebAPI> {
    return this.http.get<RespostaWebAPI>(`${UrlApi.URL_API}pergunta/porid/${perguntaId}`)
      .pipe(map((response: RespostaWebAPI) => response));
    //return this.mockPerguntas(perguntaId);
  }

  obterIDsPerguntas(areaParticipacaoId: number): Observable<number[]> {
    return this.http.get<number[]>(`${UrlApi.URL_API}pergunta/idsperguntas/${areaParticipacaoId}`);
  }

  private mockPerguntasId(areaParticipacaoId: number): Observable<number[]> {
    let perguntaId = Array<number>();

    for (let index = 0; index < 10; index++) {
      perguntaId.push(faker.random.number({ min: 1, max: 10 }));
    }

    return of(perguntaId);
  }

  private mockPerguntas(perguntaId: number): Observable<Pergunta> {
    let pergunta = new Pergunta();
    pergunta.perguntaid = perguntaId;
    pergunta.descricao = faker.lorem.lines(3);
    pergunta.enquenteid = 1;
    pergunta.multiplaescolha = faker.random.boolean();

    return of(pergunta);
  }

}
